export { InternalLink } from './InternalLink'
export type { InternalLinkProps } from './InternalLink'
